import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";

import { useMemo } from "react";
import React from "react";

export interface PhoneOption {
  key: string;
  value: string;
  label: React.ReactNode;
}

export const usePhoneOptions = (): PhoneOption[] => {
  return useMemo(() => {
    return getCountries().map((countryCode) => {
      const dialCode = getCountryCallingCode(countryCode);
      const Flag = flags[countryCode as keyof typeof flags];

      return {
        key: countryCode,
        value: countryCode,
        label: (
          <div className="flag-wrapper-container">
            {Flag && (
              <div className="flag-icon-input">
                <Flag title={countryCode} />
              </div>
            )}
            {`${countryCode.toUpperCase()} (+${dialCode})`}
          </div>
        ),
      };
    });
  }, []);
};
